export const EVENT_LABEL = 'terraform_banner';
export const DISMISS_EVENT = 'dismiss_banner';
export const CLICK_EVENT = 'click_button';
